export const kinds = {
  Tangram: 'Tangram',
  RDStation: 'RDStation',
  RDStationAppstore: 'RDStationAppstore',
  RDStationCRM: 'RDStationCRM',
  RDStationContas: 'RDStationContas',
  RDStationMarketing: 'RDStationMarketing'
};